import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // altura do navbar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-md border-b border-border/30 shadow-sm" data-testid="navbar">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="#" className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <span className="text-primary">Easy</span><span className="text-foreground">Order</span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-muted-foreground hover:text-foreground font-medium transition-colors cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-muted-foreground hover:text-foreground font-medium transition-colors cursor-pointer"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-muted-foreground hover:text-foreground font-medium transition-colors cursor-pointer"
            >
              FAQ
            </button>
            <a
              href="https://app.easyorder.delivery/login"
              className="text-foreground hover:text-primary font-medium transition-colors"
              data-testid="nav-login"
            >
              Login
            </a>
            <a
              href="https://app.easyorder.delivery/informacoes"
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 rounded-full font-semibold transition-all shadow-md hover:shadow-lg"
              data-testid="nav-signup"
            >
              Sign Up Free
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-secondary/10 transition-colors"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-border/50" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('features')}
                className="text-muted-foreground hover:text-foreground font-medium transition-colors py-2 text-left"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-muted-foreground hover:text-foreground font-medium transition-colors py-2 text-left"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="text-muted-foreground hover:text-foreground font-medium transition-colors py-2 text-left"
              >
                FAQ
              </button>
              <a
                href="https://app.easyorder.delivery/login"
                className="text-foreground hover:text-primary font-medium transition-colors py-2"
              >
                Login
              </a>
              <a
                href="https://app.easyorder.delivery/informacoes"
                className="bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 rounded-full font-semibold transition-all shadow-md text-center"
              >
                Sign Up Free
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;